import { createSelector } from 'reselect';
import { v4 as uuidv4 } from 'uuid';
import {
  data as dataSelector,
  data2 as data2Selector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import { isNumeric } from '../../../../js/app/react/validators';

const childrenSelector = createSelector(dataSelector, data =>
  (data(`${BACKEND_KEY}.Dependents`) || []).map(child => {
    if (child.frontEndId) {
      return child;
    }
    return {
      ...child,
      frontEndId: uuidv4(),
    };
  }),
);

export const indexSelector = createSelector(data2Selector, data2 => {
  const index = data2(`${BACKEND_KEY}.ChildrenStepIndex`);
  if (isNumeric(index)) {
    return index;
  }
  return -1;
});

export const childSelector = createSelector(childrenSelector, indexSelector, (children, index) => {
  if (index < 0) {
    throw new Error('childSelector: Index was not set');
  }
  return children[index];
});

export const isEditSelector = createSelector(
  data2Selector,
  data2 => !!data2(`${BACKEND_KEY}.ChildrenStepIsEdit`),
);

export default childrenSelector;
